import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBusinessTeamGoal = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "business-team-goal" }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M20.651,23.25a6.73,6.73,0,0,0-6.337-4.5h-.006a6.729,6.729,0,0,0-6.336,4.5"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M10.754,11.031A6.857,6.857,0,0,0,18.4,12.567"
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "a",
			cx: 14.308,
			cy: 13.125,
			r: 4.125
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "a",
			cx: 4.975,
			cy: 15.75,
			r: 3
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M5.864,20.338A4.482,4.482,0,0,0,.75,23.25"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 14.311,
			y1: 18.75,
			x2: 14.311,
			y2: 23.25
		}),
		/* @__PURE__ */ _jsx("polyline", {
			className: "a",
			points: "23.25 23.25 23.25 0.75 10.5 0.75 13.5 3.75 10.5 6.75 23.25 6.75"
		})
	]
});
export default SvgBusinessTeamGoal;
